import { Button, styled } from '@mui/material'

const StyledButton = styled(Button)(({ theme }) => ({
  width: '100%',
  height: '55px',
  minHeight: '55px',
  backgroundColor: theme.palette.neutral000,
  borderRadius: 0,

  ...theme.typography.subtitle3,
  '&:hover': {
    backgroundColor: theme.palette.neutral000,
  },
}))

export const ACTION_BUTTON_HEIGHT = 55
export function ActionButton({
  text,
  alertMode,
  onClick,
}: {
  text: string
  alertMode?: boolean
  onClick: () => unknown
}) {
  return (
    <StyledButton
      sx={{ color: alertMode ? 'error.main' : 'secondary.main' }}
      onClick={onClick}
    >
      {text}
    </StyledButton>
  )
}

ActionButton.defaultProps = {
  alertMode: false,
}
